/*
 *
 * PortalTextBlocked
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 27-Jun-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton } from '@mui/material'
import './PortalTextBlocked.scss'
import PortalTooltip from '@nexidigital/portaltooltip'

// This should be renamed to match the library component, something like MerchantTextBlocked
const PortalTextBlocked = ({ label, value, isLoading, textTooltip, infoToShow, id, noPadding }) => (
  <div className={`portal_text_blocked_container ${noPadding ? 'noPadding' : ''}`}>
    {label && (
      <span className='label' id={id}>
        {label}
        {textTooltip && <PortalTooltip size='xs' text={textTooltip} infoToShow={infoToShow} />}
      </span>
    )}
    {isLoading ? (
      <Skeleton variant='rectangular' className='textBlockSkeletonRow' animation='wave' />
    ) : (
      <span className='value'>{value || value === 0 ? value : '-'}</span>
    )}
  </div>
)

PortalTextBlocked.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isLoading: PropTypes.bool,
  textTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  infoToShow: PropTypes.array,
  id: PropTypes.string,
  noPadding: PropTypes.bool
}

PortalTextBlocked.defaultProps = {
  label: '',
  isLoading: false,
  textTooltip: '',
  infoToShow: null,
  id: '',
  noPadding: false
}

export default PortalTextBlocked
